<template lang="pug">
  .menu-left.menu-left--hide
    .menu-left__wr
      .menu-left__mobile-btn-close
        SvgIcon(name="close" width="27" height="27" class="menu-left__mobile-btn-close-ico")
      router-link.menu-left__logo-wr(to="/", data-src="/img/logo.svg")
        img.menu-left__logo.menu-left__logo--hide(src="@/assets/img/logo.svg")
      .menu-left__nav-wr
        .menu-left__nav(v-if="data.nav")
          router-link.menu-left__nav-item(v-for="item in data.nav", :to="item.link", :key="item.id", v-on:click.native="closeMenuLocal()")
            .menu-left__nav-item-text {{item.title}}
            .menu-left__nav-item-line
        .menu-left__contacts
          .menu-left__contacts-item(v-if="data.address")
            SvgIcon(name="address" width="20" height="24" class="menu-left__contacts-item-ico")
            .menu-left__contacts-item-text(v-html="data.address.title")
          .menu-left__contacts-item(v-if="data.time")
            SvgIcon(name="time" width="22" height="22" class="menu-left__contacts-item-ico")
            .menu-left__contacts-item-text(v-html="data.time.title")
          .menu-left__contacts-item(v-if="data.phone")
            SvgIcon(name="phone" width="22" height="22" class="menu-left__contacts-item-ico")
            a.menu-left__contacts-item-link(v-for="item in data.phone", :href="item.href", :key="item.id") {{item.title}}
          Samedia
</template>

<script>
import EventBus from '@/eventBus';
//import '@/components/common/menuLeft/menuLeft.styl';
import {ImagePreloaderVue} from '@/mixins/ImagePreloaderVue';
import {CommonHelpersVue} from '@/mixins/CommonHelpersVue';
import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';
import Samedia from '@/components/common/samedia/Samedia.vue';

export default {
  components: {
    SvgIcon,
    Samedia
  },

  name: "menuLeft",

  mixins: [ImagePreloaderVue, CommonHelpersVue],

  props: {
    data: {
      type: Object,
      required: true,
      default: null
    }
  },

  created() {
    EventBus.$on('pageLoaded', () => {
      let path = this.$route.path || '';

      this.$nextTick(() => {
        this.imgPreloader('menu-left__logo-wr', 'menu-left__logo', '', 250);
        this.setInitialActiveClass(path);
      });
    });

    this.$nextTick(() => {
      this.setActiveClass();
      this.mobileBtnInit();
    });
  },

  methods: {
    closeMenuLocal() {
      this.closeMenuMain();
      this.closeMenuPageMenu();
    },

    mobileBtnInit() {
      let that = this;

      //$(document).on('click', '.menu-left__mobile-btn',  function() {
      //  $('.menu-left').toggleClass('menu-left--mobile-open');
      //});

      $(document).on('click', '.menu-left__mobile-btn-close',  function() {
        that.closeMenuLocal();
      });
    },

    setInitialActiveClass(path) {
      let pathArr = path.split('/');

      $('.menu-left__nav-item').removeClass('menu-left__nav-item--active');

      if(pathArr[2] && pathArr[2] == 'almanakh-vin') {
        $(`.menu-left__nav-item[href*='${pathArr[2]}']`).addClass('menu-left__nav-item--active');
        return false;
      }

      if(pathArr[1]) {
        $(`.menu-left__nav-item[href$='${pathArr[1]}']`).addClass('menu-left__nav-item--active');
      }
      else {
        $('.menu-left__nav-item').eq(0).addClass('menu-left__nav-item--active');
      }
    },

    setActiveClass() {
      $(document).on('click', '.menu-left__nav-item', function() {
        $('.menu-left__nav-item').filter('.menu-left__nav-item--active').removeClass('menu-left__nav-item--active');

        $(this).addClass('menu-left__nav-item--active');
      });
    }
  }
}
</script>
